export const INITIAL_STATE = {
    screenWidth: 1024,
    screenHeight: 768
  };